<div class="empty-state-container">
  <h3>Le tableau est vide</h3>
  <p>
    Aucun acte récent à afficher pour le moment. Les actes plus anciens sont
    disponibles dans l’onglet
    <span class="empty-state-container-orange-word">Archives</span>.
  </p>
</div>
